const Header = {
	init() {
		Header.events();
		Header.toggle();
		Header.subMenu();
	},

	events() {
		Header.scroll();
		$(window).scroll(function () {
			Header.scroll();
		});
	},

	toggle() {
		var windowScrollTop = $(window).scrollTop();
		//nav desktop
		$(document).on('mouseover', '.menu-item-has-children', function() {
			$(this).children('.sub-menu').addClass('active');
		}),
		$(document).on('mouseout', '.menu-item-has-children', function() {
			$(this).children('.sub-menu').removeClass('active');
		}),
		// toggle main navigation mobile
		$(".toggle-menu").on("click", function (e) {
			e.preventDefault();

			$(this).toggleClass("active");

			$(".header").toggleClass(
				"header--was-scrolled",
				$(".header").hasClass("header--scrolled")
			);
			if (!$(".header").hasClass("header--mobile-open"))
				windowScrollTop = $(window).scrollTop();
			$(".header").toggleClass("header--mobile-open");
			$("html").toggleClass("no-scroll");
			$("html, body").scrollTop(windowScrollTop);
		});

		// Toggle dropdown
		$(".languages__toggle").on("click", function (e) {
			e.preventDefault();
			var btn = $(this);
			btn.toggleClass("languages__toggle-open");
			btn.next().slideToggle(250);
		});
	},

	subMenu() {
		// Submenu functionality
		$(".menu-item__toggle-submenu").on("click", function (e) {
			e.preventDefault();
			var btn = $(this);
			var menuItem = btn.closest(".menu-item");
			var siblings = menuItem.siblings();

			menuItem.toggleClass("menu-item--submenu-open");
			menuItem.find(".sub-menu").slideToggle(250);

			siblings.children(".sub-menu").slideUp(250);
			siblings.removeClass("menu-item--submenu-open");

			if ($(".menu-item--submenu-open").length) {
				$("html").addClass("no-scroll");
			} else {
				$("html").addClass("no-scroll");
			}
		});
	},

	scroll() {
		var st = $(window).scrollTop();
		if (st > 110) {
			$(".header").addClass("header--scrolled");
		} else {
			$(".header").removeClass("header--scrolled");
		}
	},
};
export default Header;
